module.exports = __webpack_public_path__ + "static/media/UN-06.b2c150f8.jpg";